import React, { Component } from 'react'

class Expire extends Component {
	componentWillMount(){
		this.state = {
			visible: true
		}
	}
	componentWillReceiveProps(nextProps) {
		// reset the timer if children are changed
		if (nextProps.children !== this.props.children) {
			this.setTimer()
			this.setState({ visible: true })
		}
	}
	componentDidMount() {
		this.setTimer()
	}
	setTimer() {
		// clear any existing timer
		if (this._timer != null)
			clearTimeout(this._timer)

		// hide after `delay` milliseconds
		this._timer = setTimeout(function () {
			this.setState({ visible: false });
			this._timer = null;
		}.bind(this), this.props.delay);
	}
	render() {
		const {children, hasContainer} = this.props
		return this.state.visible
			? hasContainer === true ? <span>{children}</span> : React.createElement(children[1].type, children[1].props)
			: <span />

	}
}

Expire.defaultProps = {
	delay: 100
}
export default Expire


// WEBPACK FOOTER //
// ./src/components/framework/Expire.jsx